import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import React, { useContext, useRef, useState } from 'react'
import slugify from 'react-slugify'
import Context from '../../context'
import { checkSlug } from '../../services/ClubeApi'

function ScriptData({ checkIsRed }) {
  const slugInput = useRef()

  const { formObject, setFormObject, setOpenToast } = useContext(Context)
  const [tempSlug, setTempSlug] = useState('')
  const [warnClass, setWarnClass] = useState('')

  const slugifyText = () => {
    setFormObject({
      ...formObject,
      slug: slugify(formObject.slug)
    })

    if (formObject.slug.length > 0) {
      checkSlug(slugify(formObject.slug)).then(r => {
        if (!r && tempSlug !== formObject.slug) {
          setOpenToast({
            open: true,
            message: 'Slug não disponível, favor inserir outro.',
            type: 'error'
          })
          slugInput.current.focus()
          setWarnClass('clube-border-danger')
        } else {
          setOpenToast({
            open: false,
            message: '',
            type: 'error'
          })
          setWarnClass('')
        }
      })
    } else {
      // checkValue('slug', formObject.slug);
    }
  }

  const handleStartDateChange = date => {
    setFormObject({ ...formObject, startDate: date })
  }

  const handleEndDateChange = date => {
    setFormObject({ ...formObject, endDate: date })
  }

  return (
    <>
      <h5>Dados do Roteiro</h5>
      <div className="row">
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title1">Título 1</label>
          <input
            value={formObject.title1 || ''}
            onChange={e => setFormObject({ ...formObject, title1: e.target.value })}
            type="text"
            className="form-control"
            id="title1"
            placeholder="Título 1"
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title1Color">Cor do Título 1</label>
          <input
            value={formObject.title1Color || '#250074'}
            onChange={e => setFormObject({ ...formObject, title1Color: e.target.value })}
            type="color"
            className="form-control"
            id="title1Color"
            placeholder="#FFFFFF"
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title1Color">Cor do Título 1</label>
          <input
            value={formObject.title1Color || '#250074'}
            onChange={e => setFormObject({ ...formObject, title1Color: e.target.value })}
            className="form-control"
            placeholder="#FFFFFF"
          />
        </div>
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title2">Título 2</label>
          <input
            value={formObject.title2 || ''}
            onChange={e => setFormObject({ ...formObject, title2: e.target.value })}
            type="text"
            className="form-control"
            id="title2"
            placeholder="Título 2"
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title2Color">Cor do Título 2</label>
          <input
            value={formObject.title2Color || '#FFFFFF'}
            onChange={e => setFormObject({ ...formObject, title2Color: e.target.value })}
            type="color"
            className="form-control"
            id="title2Color"
            placeholder="#FFFFFF ou green"
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title2Color">Cor do Título 2</label>
          <input
            value={formObject.title2Color || '#FFFFFF'}
            onChange={e => setFormObject({ ...formObject, title2Color: e.target.value })}
            className="form-control"
            placeholder="#FFFFFF ou green"
          />
        </div>
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="slug">Slug do Roteiro</label>
          <input
            ref={slugInput}
            onChange={e => setFormObject({ ...formObject, slug: e.target.value })}
            value={formObject.slug}
            type="text"
            className={`form-control ${warnClass} ${checkIsRed('slug') && 'clube-border-danger'}`}
            id="slug"
            placeholder="Slug"
            onBlur={slugifyText}
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="backgroundColor">Cor do Fundo</label>
          <input
            value={formObject.backgroundColor || '#ff8647'}
            onChange={e => setFormObject({ ...formObject, backgroundColor: e.target.value })}
            type="color"
            className="form-control"
            id="backgroundColor"
            placeholder="#FFFFFF"
          />
        </div>
        <div className="col-md-3 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="backgroundColor">Cor do Fundo</label>
          <input
            value={formObject.backgroundColor || '#ff8647'}
            onChange={e => setFormObject({ ...formObject, backgroundColor: e.target.value })}
            className="form-control"
            placeholder="#FFFFFF"
          />
        </div>
        <div className="col-6 d-flex flex-row justify-content-between">
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              margin="normal"
              id="startDate"
              label="Do dia..."
              format="DD/MM/YYYY"
              value={formObject.startDate}
              onChange={handleStartDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              margin="normal"
              id="endDate"
              label="Até dia..."
              format="DD/MM/YYYY"
              minDate={formObject.startDate}
              minDateMessage="A Data final não pode ser inferior ao início."
              value={formObject.endDate}
              onChange={handleEndDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div className="col-12">
          <label htmlFor="description">Descrição sobre o Roteiro</label>
          <textarea
            className="form-control"
            id="description"
            rows="6"
            style={{ width: '100%' }}
            value={formObject.description}
            onChange={e => setFormObject({ ...formObject, description: e.target.value })}
            placeholder="Descrição sobre o Roteiro"
          />
        </div>
      </div>
    </>
  )
}

export default ScriptData
